import styled from "styled-components";

export const SectionContainer = styled.div.attrs({
  className: "SectionContainer",
})`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  margin: auto;
  max-width: 1080px;
  padding-bottom: 8rem;

  & .PageHeaderContainer .Body {
    font-size: 3.2rem;
  }
`;
